import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../lib/api";
import { Siren, Timer } from "@phosphor-icons/react";

/** Admin dashboard banner — live lone-worker sessions, with overdue / alarm states shouted loudly. Polls every 30s. */
export default function LoneWorkerAlerts() {
  const [data, setData] = useState(null);
  const load = useCallback(() => API.get("/lone-worker/sessions", { params: { status: "live" } }).then((r) => setData(r.data)).catch(() => setData(null)), []);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);
  if (!data || !data.sessions?.length) return null;
  const urgent = data.sessions.filter((s) => s.status === "alarm" || s.status === "overdue");
  const alarm = urgent.some((s) => s.status === "alarm");
  return (
    <Link to="/health-safety?tab=lone-worker" className={`mb-6 flex items-center gap-3 rounded-lg border p-3 text-sm transition-colors ${alarm ? "border-red-500 bg-red-500/10 animate-pulse hover:bg-red-500/15" : urgent.length ? "border-amber-400 bg-amber-500/10 hover:bg-amber-500/15" : "border-border bg-card hover:border-primary/50"}`} data-testid="lone-worker-alerts">
      {urgent.length ? <Siren size={20} weight="fill" className={alarm ? "text-red-600" : "text-amber-600"} /> : <Timer size={20} className="text-emerald-600" />}
      <div className="min-w-0 flex-1">
        {urgent.length ? (
          <p className="font-semibold" data-testid="lone-worker-alerts-urgent">{alarm ? "Lone-worker ALARM" : "Lone-worker check-in overdue"} — {urgent.map((s) => `${s.user_name}${s.job_reference ? ` (${s.job_reference})` : ""} · ${s.overdue_minutes} min`).join(", ")}</p>
        ) : (
          <p className="font-medium" data-testid="lone-worker-alerts-active">{data.counts.active} lone worker{data.counts.active === 1 ? "" : "s"} on a timer — {data.sessions.map((s) => s.user_name).join(", ")}</p>
        )}
        <p className="text-xs text-muted-foreground">Open the lone-worker board to call them or mark them safe.</p>
      </div>
    </Link>
  );
}
